export default __webpack_public_path__ + "static/media/Platinum_1_Rank.488ab6dd.png";